import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Store, MapPin } from 'lucide-react';
import Card from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import Table from '../../components/ui/Table';
import api from '../../services/api';

export default function StoreList() {
  const navigate = useNavigate();
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      setLoading(true);
      try {
        const res = await api.get('/v1/stores');
        if (res?.data) setStores(res.data);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    }
    load();
  }, []);

  const columns = [
    { key: 'source_code', label: 'Код', render: v => <code style={{ background: '#E6FAFB', padding: '3px 8px', borderRadius: 6, fontSize: 12, fontWeight: 700, color: '#009995' }}>{v || '\u2014'}</code> },
    { key: 'name', label: 'Название', render: v => <span style={{ fontWeight: 600 }}>{v}</span> },
    { key: 'address', label: 'Адрес', render: v => <span style={{ color: '#64748B', fontSize: 12 }}>{v || '\u2014'}</span> },
    { key: 'is_active', label: 'Статус', render: v => <Badge variant={v ? 'success' : 'error'} dot>{v ? 'Активен' : 'Неактивен'}</Badge> },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div>
        <h1 style={{ fontSize: 24, fontWeight: 800, color: '#0F172A', letterSpacing: '-0.02em' }}>Магазины</h1>
        <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 2, fontWeight: 500 }}>Всего: {stores.length} {loading && '(загрузка...)'}</p>
      </div>

      {!loading && stores.length > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 14 }}>
          {stores.map(s => (
            <div key={s.id} onClick={() => navigate(`/stores/${s.id}`)} style={{
              background: '#fff', borderRadius: 16, padding: 20,
              border: '1px solid #E2E8F0', cursor: 'pointer',
              transition: 'all 0.2s ease',
              boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
            }}
              onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,206,238,0.12)'; e.currentTarget.style.borderColor = '#00CEEE'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
              onMouseLeave={e => { e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.04)'; e.currentTarget.style.borderColor = '#E2E8F0'; e.currentTarget.style.transform = 'translateY(0)'; }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
                <div style={{
                  width: 46, height: 46, borderRadius: 12,
                  background: 'linear-gradient(135deg, #E6FAFB, #D0F5F5)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                }}>
                  <Store size={21} color="#009995" />
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 700, fontSize: 14, color: '#0F172A' }}>{s.name}</div>
                  {s.address && (
                    <div style={{ fontSize: 12, color: '#94A3B8', marginTop: 3, display: 'flex', alignItems: 'center', gap: 4 }}>
                      <MapPin size={11} /> {s.address}
                    </div>
                  )}
                  <code style={{
                    fontSize: 11, color: '#009995', background: '#E6FAFB',
                    padding: '2px 8px', borderRadius: 4, marginTop: 6, display: 'inline-block',
                  }}>{s.source_code}</code>
                </div>
              </div>
              <div style={{ display: 'flex', gap: 8, marginTop: 14, paddingTop: 12, borderTop: '1px solid #F1F5F9' }}>
                <Badge variant={s.is_active ? 'success' : 'error'} dot>{s.is_active ? 'Активен' : 'Неактивен'}</Badge>
              </div>
            </div>
          ))}
        </div>
      )}

      <Card padding="0" title="Список магазинов">
        {loading ? (
          <div style={{ textAlign: 'center', padding: 48, color: '#94A3B8' }}>
            <div style={{ width: 28, height: 28, borderRadius: '50%', border: '3px solid rgba(0,206,238,0.15)', borderTopColor: '#00CEEE', animation: 'spin 0.8s linear infinite', margin: '0 auto 10px' }} />
            Загрузка...
          </div>
        ) : (
          <Table columns={columns} data={stores} onRowClick={row => navigate(`/stores/${row.id}`)} emptyText="Магазины не найдены" />
        )}
      </Card>
    </div>
  );
}
